import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { PlaceService } from '@app/modules/model/svcplace';

import { languageService, languageSupport } from '@app/modules/common/language';
import { deviceService } from '@app/modules/sockets';
import { dataService } from '@app/modules/data';
import { syncService } from '@app/modules/sync';
import { viewService } from '@app/modules/view';

/************************************/
/* USER COMPONENT                   */
/************************************/

@Component({
    selector: 'ui-rasppi-thumb',
    templateUrl: 'ui-thumb.html',
    styleUrls: [
      'ui-thumb.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiRaspPIThumb extends languageSupport  implements OnInit, OnChanges, OnDestroy { 
    @Input('service') _service: PlaceService = null;
    @Input('active') _active = false;

    get PosCheck(){
        let _connects = this._service.connected;
        if (_connects.length == 0){
            return 'ERROR';
        }

        for (let _connect of _connects){
            if (_connect.IsValid && (_connect.device == this.data.device)){
                return 'MYPOS';
            }
        }

        return null;    // this is other POS with connected devices
    }

    get TableCount(){
        let _tables = [];

        for (let _table of this._service.tables){
            if (_table.IsValid){
                _tables.push(_table);
            }
        }

        return _tables.length;
    }

    get DevcsCount(){
        let _devices = [];

        for (let _printer of this._service.printers){
            if (_printer.IsValid){
                _devices.push(_printer);
            }
        }

        for (let _scale of this._service.scales){
            if (_scale.IsValid){
                _devices.push(_scale);
            }
        }

        return _devices.length;
    }

    get ConntCount(){
        return this._service.connected.length || 0;
    }

    get SvcCheck(){
        let _hassvc = this._service.connected.some(
        _connect => {
            return (_connect.rasppi == this._service) && _connect.hassvc;
        });

        return _hassvc;
    }

    private async _CheckStatus(){
        let _connection = await this.devsvc.Test(null, null, this._service.name, false);
        this._service.IsOnline = !!_connection;
    }

    private _check_interval = null;
    private _check_ticksecs = 0;    // check every 5 seconds

    RunCheck(){
        if (this._check_interval == null){
            this._check_interval = this.sync.Clock.OnOneSecondTick.subscribe(
            data => {
                this._check_ticksecs = (this._check_ticksecs + 1) % 5;
                if (this._active && (this._check_ticksecs == 0)){  // do not check if not active
                    this._CheckStatus();
                }
            });
        }

        return this._service.IsOnline;
    }

    /****************************/
    /* STARTS HERE              */
    /****************************/

    private _service_subscriptions = [];

    constructor(private lang: languageService, private change: ChangeDetectorRef, private devsvc: deviceService, private data: dataService, private sync: syncService, public view: viewService) {
        super(lang, change);
    }

    ngOnInit(){
        this._CheckStatus();    // perform first check
    }

    ngOnChanges(){
        for (let _subscription of this._service_subscriptions){
            _subscription.unsubscribe;
            _subscription = null;
        }
        this._service_subscriptions = [];

        if (this._service){
            this._service_subscriptions.push(this._service.OnRefresh.subscribe(data => {
                this.change.markForCheck();
            }));

            for (let _connection of this._service.connected){
                this._service_subscriptions.push(_connection.OnRefresh.subscribe(data => {
                    this.change.markForCheck();
                }));
            }
        }
    }

    ngOnDestroy(){
        super.OnDestroy();

        for (let _subscription of this._service_subscriptions){
            _subscription.unsubscribe;
            _subscription = null;
        }        
        this._service_subscriptions = [];

        if (this._check_interval){
            this._check_interval.unsubscribe();
            this._check_interval = null;
        }        
    }

    /****************************/
    /* EVENT HANDLERS           */
    /****************************/
    
    @Output('OnEdit') _onedit = new EventEmitter <any> ();
    OnEditPOS(){
        this._onedit.next();
    }
}
